<template>
  <w-stack gap="small">
    <w-link
      v-for="{ label, back, isLoading } in breadcrumbs"
      :key="back"
      :to="back"
      :color-inherit="false"
      trailing-icon="caret-right"
      class="breadcrumb-shrink"
    >
      <w-skeleton-text
        v-if="isLoading"
        variant="body"
        width="100px"
        :lines="1"
      />
      <span
        v-else
        class="breadcrumb-truncate"
        >{{ label }}</span
      >
    </w-link>
  </w-stack>
</template>

<script lang="ts" setup>
import { WLink, WSkeletonText, WStack } from '@dp-watson-web/components';

import { useRouterBreadcrumb } from '@/shared/layouts/base/composables/breadcrum.composable';

const { breadcrumbs } = useRouterBreadcrumb();
</script>

<style lang="scss" scoped>
button {
  padding-left: 0;
}

.breadcrumb-shrink {
  min-width: 0;
  flex-shrink: 1;
}

.breadcrumb-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
